import TextAndImageConnector from './TextAndImageConnector';

/**
 * @typedef {Object} TextAndImageWidgetElementOptions
 * @property {string} cssClasses
 * @property {string} itemCssClasses
 * @property {string} selectedCssClasses
 * @property {string} imageCssClasses
 * @property {string} textCssClasses
 */

export default class TextAndImageWidget {
    /**
     *
     * @param {HTMLElement|string} container
     * @param {TextAndImageWidgetElementOptions} elementOptions
     * @param {Object} widgetParams
     * @return {TextAndImageConnector}
     */
    static create(container, elementOptions, widgetParams) {
        return new TextAndImageWidget(container, elementOptions).makeWidget(widgetParams);
    }

    /**
     *
     * @param {HTMLElement|string} container
     * @param {TextAndImageWidgetElementOptions} elementOptions
     */
    constructor(container, elementOptions = {}) {
        if (typeof container === 'string') {
            container = document.querySelector(container);
        }

        if (!container instanceof HTMLElement) {
            throw new Error('Invalid container');
        }

        this.containerNode = container;
        this.elementOptions = elementOptions;
    }

    get listElementClasses() {
        return this.elementOptions.cssClasses || '';
    }

    get itemElementClasses() {
        return ('card cursor-pointer '+ this.elementOptions.itemCssClasses || '').trim();
    }

    get selectedElementClasses() {
        return (this.elementOptions.selectedCssClasses || '--is-selected').split(' ');
    }

    get imageElementCssClasses() {
        return ('card-img-top ' + this.elementOptions.imageCssClasses || '').trim();
    }

    get textElementCssClasses() {
        return ('card-body ' + this.elementOptions.textCssClasses || '').trim();
    }

    _createTextAndImageFacetItem(facetItem) {
        let textImageElement = document.createElement('div');

        textImageElement.setAttribute('class', this.itemElementClasses);
        textImageElement.setAttribute('role', 'listitem');
        textImageElement.dataset['facetId'] = facetItem.id;
        textImageElement.dataset['uuid'] = facetItem.uuid;

        textImageElement.innerHTML = `<div class="${this.imageElementCssClasses}">${facetItem.image}</div><div class="${this.textElementCssClasses}"><span>${facetItem.text}</span></div>`;

        return textImageElement;
    }

    _render(options) {
        // Cast the active item id to number
        let activeFacetItemId = options.activeItem * 1,
            widgetContentNode = document.createElement('div');

        widgetContentNode.setAttribute('class', this.listElementClasses);
        widgetContentNode.setAttribute('role', 'list');
        options.items.forEach(item => {
            let facetItemElement = this._createTextAndImageFacetItem(item);
            if (activeFacetItemId === item.id) {
                facetItemElement.classList.add(...this.selectedElementClasses);
            }

            facetItemElement.addEventListener('click', () => options.refine(item.id));
            widgetContentNode.appendChild(facetItemElement);
        });

        this.containerNode.innerHTML = '';
        this.containerNode.append(widgetContentNode);
    }

    _dispose() {
        this.containerNode.innerHTML = '';
    }

    makeWidget(widgetParams) {
        return new TextAndImageConnector(widgetParams, (options) => this._render(options), () => this._dispose())
    }
}